<template>
  <section :data-update="forceUpate">
    <div class="max-w-6xl mx-auto px-4 sm:px-6">
      <HeaderSection :banner="banner">
        <h3
          class="text-lg md:text-3xl text-white mb-2"
          v-html="$t('event.intro.title')"
        ></h3>
        <p class="text-white lg:text-lg">
          <span v-html="$t('event.welcomeWord')"></span>
        </p>
      </HeaderSection>
    </div>
    <div class="px-4 mx-auto max-w-6xl sm:px-6">
      <div class="shadow-xl bg-white text-left p-6 pb-12 md:pb-20">
        <div
          class="mx-auto text-center text-2xl text-gray-800"
          v-html="$t('event.thanksWork')"
        ></div>
        <vue-qrcode
          v-if="showQr && info.attendeeNumber"
          class="mx-auto"
          :value="info.attendeeNumber"
          :options="{ width: 200 }"
          :title="qr"
        ></vue-qrcode>
        <div class="text-center">
          <p v-if="info.attendeeNumber">{{ $t("報名編號") }}:{{ info.attendeeNumber }}</p>
          <p v-if="$te('session.eventTimePeriod')">{{ $t("日期及時間") }}:{{ $t("session.eventTimePeriod") }} 
          <p v-if="$te('session.address')">{{ $t("地點") }}:{{ $t("session.address") }}</p>
          
          <button
            type="button"
            @click="$router.push('/')"
            class="
              mx-auto
              mt-4
              px-4
              py-2
              rounded
              bg-green-500
              text-white
              hover:bg-green-600
              disabled:opacity-50
            "
          >
            <span class="formulate-input-element--button--label">{{
              $t("返回")
            }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
 
<script>
import HeaderSection from "../components/HeaderSection.vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import {submitI18n } from "../utils/helper";

import { applyFormi18n } from "../utils/helper";
import { updateMessages } from "@/libs/i18n";
import { getBannerUrl } from '../api/fetchEvent';

export default {
  components: {
    HeaderSection,
    VueQrcode,
  },
  methods: {
    async getEvent() {
      this.applyForm = window.applyForm ;
      this.showQr = this.applyForm.form.isShowQRCode;
      this.eventI18n = applyFormi18n(this.applyForm);
      updateMessages(this.eventI18n);
      this.forceUpate = 1;

      let b = this.eventI18n[this.$i18n.locale]["event.intro.banner"];
      if (b && b.length) {
        this.banner = getBannerUrl(b[0])
      } else {
        this.banner = false;
      }
    },
    getThankyou() {
      console.log("method getThankyou");
      let i = submitI18n(window.thankyou.data);
      window.thankyou.data.i18n = i;
      return window.thankyou.data;
    },
    async initView(){
      if (!window.thankyou || !window.applyForm) {
        this.$router.push("/");
      } 
      await this.getEvent();
      this.info = this.getThankyou();
      updateMessages(this.info.i18n);
      console.log("this.info", this.info);
    },
  },

  async mounted() {
    await this.initView()
    this.$forceUpdate();
  },
  
  async beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate',{to, from, next})
    await this.initView()
    next();
    this.$forceUpdate();
  },
  data() {
    return {
      showQr: false,
      qr: this.$route.params["uuid"],
      msg: false,
      forceUpate: 0,
      banner: false,
      info: {},
    };
  },
};
</script>